import {
  DeleteOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Collapse,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { Option } from "antd/lib/mentions";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import { ReactComponent as ArchiveButtonicon } from "../../../image/ArchiveButtonicon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import BulkRateUploadExcel from "./BulkRateUploadExcel";

const { Search } = Input;

const NewDeliveryRateList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const { Panel } = Collapse;
  const [loading, setLoading] = useState(false);
  const [deliveryrates, setdeliveryrates] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [deliveryRateLoading, setDeliveryRateLoading] = useState(false);

  const [reload, setReload] = useState(false);
  // const [btnLoading, setBtnLoading] = useState(false);
  const [btnDisplay, setBtnDisplay] = useState("Add");
  // const [deliveryratesID, setdeliveryratesID] = useState(null);
  const deliveryFormRef = useRef();
  const [companyDocumentId, setCompanyDocumentId] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [newRateAdded, setNewRateAdded] = useState(false);

  const [rateId, setRateId] = useState(null);
  // const [modalKey, setModalKey] = useState(false);
  // const initialState = {
  //   price: null,
  //   company: null,
  //   start_weight: null,
  //   start_weight_unit_of_measurement: null,
  //   end_weight: null,
  //   end_weight_unit_of_measurement: null,
  //   country: authUserData()?.country ? authUserData()?.country : 1,
  //   state: authUserData()?.state ? authUserData()?.state : 1,
  //   suburb: null,
  //   zone: null,
  //   currency: authUserData()?.currency || 'AUD',
  //   rate: "Flat Rate", // Default value
  // };

  // const [stateab, setStateab] = useState(initialState);
  const initialDocument = {
    driver: null,
    company: "",
    start_weight_unit_of_measurement: null,
    start_unit_of_measurement: "",
    end_weight_unit_of_measurement: null,
    end_unit_of_measurement: "",
    rate_type: "Variable Rate", // Default value
    // currency: authUserData()?.currency || "AUD",
    price: null,
    customer_zone: "",
    end_weight: null,
    start_weight: null,
    state: authUserData()?.state ? authUserData()?.state : 1,
    package_type: null,
  };

  const [documentState, setDocumentState] = useState(initialDocument);
  useEffect(() => {
    getunitofmeasurement();
    getcompany();
    getunitofmeasurementEnd();
    getPackageType();
  }, []);
  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getPincodeList = async () => {
      setLoading(true);

      const queryParamsObject = {
        country: stateFilter?.country || null,
        company: stateFilter?.company || null,
        start_weight: stateFilter?.start_weight || null,
        start_weight_unit_of_measurement:
          stateFilter?.start_weight_unit_of_measurement || null,
        end_weight: stateFilter?.end_weight || null,
        end_weight_unit_of_measurement:
          stateFilter?.end_weight_unit_of_measurement || null,
        price: stateFilter?.price || null,
        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      const payload = {
        customer_zone_name: stateFilter?.customer_zone_name || [],
        state_name: stateFilter?.state_name || [],
      };
      const queryParamsplusfield = `${queryParams}&fields=${"id,state_name,start_weight_unit_of_measurement_name,start_weight,end_weight,end_weight_unit_of_measurement_name,company_name,package_type_name,customer_zone_name,rate_type,price,currency_name"}`;
      try {
        let apiResponse = await patchRequest(
          `delivery-rates/?${queryParamsplusfield}`,
          payload
        );
        if (apiResponse.data.results.success) {
          setdeliveryrates(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        }
      } catch (error) {
        ErrorNotificationMsg(t("Error Fetching Delivery"));
      } finally {
        setLoading(false);
      }
    };

    getPincodeList();
  }, [state, reload, t, refreshGrid]);

  // useEffect(() => {
  //   getZoneList();
  // }, []);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setDocumentState({ ...documentState, [name]: value });
  };

  const getPackageType = async (data) => {
    await getRequest("package-type/", data).then((response) => {
      setPackageType(response.data.results.data);
    });
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    form.setFieldsValue({ search: "" });
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    // if (sortField === "country_name" && sortOrder === "ascend") {
    //   sortingEnumKey = "country__name";
    // }
    // if (sortField === "country_name" && sortOrder === "descend") {
    //   sortingEnumKey = "-country__name";
    // }
    if (sortField === "state_name" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state_name" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "street" && sortOrder === "ascend") {
      sortingEnumKey = "street_name";
    }
    if (sortField === "street" && sortOrder === "descend") {
      sortingEnumKey = "-street_name";
    }
    if (sortField === "city" && sortOrder === "ascend") {
      sortingEnumKey = "city__name";
    }
    if (sortField === "city" && sortOrder === "descend") {
      sortingEnumKey = "-city__name";
    }

    if (sortField === "customer_zone_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_zone__customer_zone";
    }
    if (sortField === "customer_zone_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_zone__customer_zone";
    }
    if (sortField === "currency" && sortOrder === "ascend") {
      sortingEnumKey = "currency";
    }
    if (sortField === "currency" && sortOrder === "descend") {
      sortingEnumKey = "-currency";
    }

    if (sortField === "price" && sortOrder === "ascend") {
      sortingEnumKey = "price";
    }
    if (sortField === "price" && sortOrder === "descend") {
      sortingEnumKey = "-price";
    }
    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    // if (sortField === "package_type" && sortOrder === "ascend") {
    //   sortingEnumKey = "company__company_name";
    // }
    // if (sortField === "package_type" && sortOrder === "descend") {
    //   sortingEnumKey = "-company__company_name";
    // }
    if (
      sortField === "start_weight_unit_of_measurement_name" &&
      sortOrder === "ascend"
    ) {
      sortingEnumKey = "start_weight_unit_of_measurement__name";
    }
    if (
      sortField === "start_weight_unit_of_measurement_name" &&
      sortOrder === "descend"
    ) {
      sortingEnumKey = "-start_weight_unit_of_measurement__name";
    }
    if (
      sortField === "end_weight_unit_of_measurement_name" &&
      sortOrder === "ascend"
    ) {
      sortingEnumKey = "end_weight_unit_of_measurement__name";
    }
    if (
      sortField === "end_weight_unit_of_measurement_name" &&
      sortOrder === "descend"
    ) {
      sortingEnumKey = "-end_weight_unit_of_measurement__name";
    }
    if (sortField === "end_weight" && sortOrder === "ascend") {
      sortingEnumKey = "end_weight";
    }
    if (sortField === "end_weight" && sortOrder === "descend") {
      sortingEnumKey = "-end_weight";
    }
    if (sortField === "start_weight" && sortOrder === "ascend") {
      sortingEnumKey = "start_weight";
    }
    if (sortField === "start_weight" && sortOrder === "descend") {
      sortingEnumKey = "-start_weight";
    }
    if (sortField === "start_weight" && sortOrder === "ascend") {
      sortingEnumKey = "start_weight";
    }
    if (sortField === "start_weight" && sortOrder === "descend") {
      sortingEnumKey = "-start_weight";
    }
    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const [checkedList, setCheckedList] = useState([
    // "country_name",
    "state_name",
    "customer_zone_name",
    "company_name",
    "package_type",
    "start_weight",
    "start_weight_unit_of_measurement_name",
    "end_weight",
    "end_weight_unit_of_measurement_name",
    "price",
    "currency",
    "operation",
  ]);

  const currencySymbols = {
    USD: "$",
    EUR: "€",
    JPY: "¥",
    INR: "₹",
    // Add more currencies as needed
  };

  const fetchCurrencySymbol = (currencyCode) => {
    return currencySymbols[currencyCode] || "$";
  };
  const handleRateTypeChange = (value) => {
    if (value === "Variable Rate") {
      setDocumentState((prevState) => ({
        ...prevState,
        rate_type: value,
        start_weight_unit_of_measurement: null,
        end_weight: null,
        start_weight: null,
        end_weight_unit_of_measurement: null,
      }));

      deliveryFormRef.current.setFieldsValue({
        start_weight_unit_of_measurement: null,
        end_weight: null,
        start_weight: null,
        end_weight_unit_of_measurement: null,
      });
    } else if (value === "Flat Rate") {
      setDocumentState((prevState) => ({
        ...prevState,
        rate_type: value,
        start_weight_unit_of_measurement: null,
        end_weight: null,
        start_weight: null,
        end_weight_unit_of_measurement: null,
      }));

      deliveryFormRef.current.setFieldsValue({
        start_weight_unit_of_measurement: null,
        end_weight: null,
        start_weight: null,
        end_weight_unit_of_measurement: null,
      });
    }
  };
  const handlePackageType = (value) => {
    setDocumentState((prevState) => ({
      ...prevState,
      package_type: value,
    }));
  };
  const [columns, setColumns] = useState([
    // {
    //   title: "Country",
    //   dataIndex: "country_name",
    //   key: "country_name",
    //   sorter: true,
    // },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state_name",
      sorter: true,
    },
    {
      title: "Zone",
      dataIndex: "customer_zone_name",
      key: "customer_zone_name",
      sorter: true,
    },
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Package Type",
      dataIndex: "package_type_name",
      key: "package_type",
      // sorter: true,
    },
    {
      title: "From Weight",
      dataIndex: "start_weight",
      key: "start_weight",
      sorter: true,
    },
    {
      title: "UoM.",
      dataIndex: "start_weight_unit_of_measurement_name",
      key: "start_weight_unit_of_measurement_name",
      sorter: true,
    },
    {
      title: "To Weight ",
      dataIndex: "end_weight",
      key: "end_weight",
      sorter: true,
    },
    {
      title: "UoM.",
      dataIndex: "end_weight_unit_of_measurement_name",
      key: "end_weight_unit_of_measurement_name",
      sorter: true,
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      sorter: true,
      render: (price, record) => (
        <span>
          {fetchCurrencySymbol(record.currency)} {price}
        </span>
      ),
    },
    {
      title: "Currency",
      dataIndex: "currency_name",
      key: "currency",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          {/* <Tooltip title="Edit" placement="left" color={colors}> */}
          {authUserData()?.permission.includes(
            "settings|change_deliveryrates"
          ) && (
            // <Editicon
            //   onClick={() => handleUpdate(record.id)}
            //   style={{ cursor: "pointer" }}
            // />
            <Editicon
              onClick={() => handleEditIconClick(record.id)}
              style={{ cursor: "pointer" }}
            />
          )}
          {/* </Tooltip> */}
          {/* <Tooltip title="Delete" placement="right" color={colors}> */}
          {authUserData()?.permission.includes(
            "settings|delete_deliveryrates"
          ) && (
            <Popconfirm
              title={t("pop_delete")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <DeleteOutlined style={{ cursor: "pointer" }} />
            </Popconfirm>
          )}
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {/* <Col span={12}>
              <Checkbox value="country_name">Country</Checkbox>
            </Col> */}
            <Col span={12}>
              <Checkbox value="state_name">State</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="customer_zone_name">Zone</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="company_name">Company</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="package_type">Package Type</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="start_weight">From Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="start_weight_unit_of_measurement_name">
                Uom.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="end_weight">To Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="end_weight_unit_of_measurement_name">
                Uom.
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="price">Price</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="currency">Currency</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="operation" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  // const handleUpdate = (id) => {
  //   setModalKey((prevKey) => !prevKey);
  //   setdeliveryratesID(id);
  //   showModal();
  // };
  const handleEditIconClick = (id) => {
    setRateId(id);
    setCompanyDocumentId(id);
    setBtnDisplay("Edit");
  };

  // const handleAdd = () => {
  //   setdeliveryratesID(null);
  //   showModal();
  // };

  const handleArchive = async (id = []) => {
    let ids = [...selectedRow];

    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await deleteRequest(
        "delivery-rates/delivery-rate-delete/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;
        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("Delivery Rate Deleted Successfully"));
        // setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("Error In Deleted Delivery Rate"));
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);


  const showBulkUploadExcel = () => {
    setIsModalOpenBulk(true);
  };
  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };

  const handleChange = (field, value) => {
    setStateFilter({ ...stateFilter, [field]: value.target.value });
  };

  const intialFilter = {
    country: "",
    company: "",
    customer_zone_name: [],
    state_name: "",
    start_weight: "",
    start_weight_unit_of_measurement: "",
    end_weight: "",
    end_weight_unit_of_measurement: "",
    price: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);
  const formRef = useRef();
  const [zones, setZones] = useState([]);
  const [states, setStates] = useState([]);
  const [zonesField, setZonesField] = useState([]);
  const [statesField, setStateFiled] = useState([]);
  const [countryName, setCountryName] = useState();
  const [unitofmeasurement, setunitofmeasurement] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [packageType, setPackageType] = useState([]);
  useEffect(() => {
    const stateId = authUserData()?.state ?? null;
    const stateName = authUserData()?.state_name ?? null;
    getCountryName();
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getZoneByState(authUserData()?.state)
      : getZoneByState(1);
    setDocumentState((prevState) => ({
      ...prevState,
      state: stateId,
    }));

    deliveryFormRef.current?.setFieldsValue({
      state: stateId,
    });
    setStateFilter((prevState) => ({
      ...prevState,
      state_name: stateName,
    }));

    formRef.current.setFieldsValue({ state: stateId });
    getunitofmeasurement();
    getCompanyList();
  }, []);

  useEffect(() => {
    // getCountryNameField();
    authUserData()?.country
      ? getStateByCountryField(authUserData()?.country)
      : getStateByCountryField(1);
    authUserData()?.country
      ? getCurrencyByCountryField(authUserData()?.country)
      : getCurrencyByCountryField(1);
    authUserData()?.state
      ? getZoneByStateField(authUserData()?.state)
      : getZoneByStateField(1);
  }, []);
  const getZoneByStateField = async (id) => {
    const zoneResponse = await getRequest(
      "customer-zone/?no_pagination=true&state_id=" + id
    );

    // setZones(zoneResponse?.data?.data);
    setZonesField(zoneResponse?.data?.data);
    // setZoneList(zoneResponse?.data?.data);
  };
  const getCurrencyByCountryField = async (id) => {
    const stateResponse = await getRequest(
      "country/get-currency/?country_id=" + id
    );

    // setState((prevState) => ({
    //   ...prevState,
    //   currency: stateResponse?.data?.data[0]?.currency,
    // }));
    // formRef.current.setFieldsValue({
    //   currency: stateResponse?.data?.data[0]?.currency,
    // });
  };
  const getStateByCountryField = async () => {
    const stateResponse = await getRequest("state/?no_pagination=true");

    setStateFiled(stateResponse?.data?.data);
  };

  // const getCountryNameField = async () => {
  //   try {
  //     setapiLoading(true);
  //     const response = await getRequest("country/?no_pagination=True");

  //     const { data } = response.data;

  //     setCountries(data);
  //     formRef.current.setFieldsValue(response.data.data);
  //     setapiLoading(false);
  //   } catch (error) {
  //     setapiLoading(false);
  //   }
  // };
  const handleCountrySelectChange = (value) => {
    setStateFilter((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    // Field(value);
  };

  const getCountryName = async (data) => {
    await getRequest("country/?no_pagination=True", data).then((response) => {
      setCountryName(response?.data?.data);
    });
  };
  const handleStateSelectChangeField = (value) => {
    console.log("State", value);
    setDocumentState((prevState) => ({
      ...prevState,
      state: value,
      customer_zone: null,
      suburb: null,
    }));

    deliveryFormRef.current.setFieldsValue({
      customer_zone: null,
      suburb: null,
    });
    setZones([]);
    getZoneByStateField(value);
  };

  const handleStateSelectChange = (value) => {
    const selectedstate = states?.find((zone) => zone.id === value);
    const stateName = selectedstate ? selectedstate.name : "";
    setStateFilter((prevState) => ({
      ...prevState,

      state_name: stateName,
      customer_zone_name: [],
    }));
    formRef.current.setFieldsValue({
      customer_zone: undefined,
      customer_zone_name: undefined,
    });
    setZones([]);
    getZoneByState(value);
  };

  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handleAreaChange = (selectedZones) => {
    setStateFilter((prevState) => ({
      ...prevState,
      customer_zone_name: selectedZones,
      suburb_id: [],
    }));

    formRef.current.setFieldsValue({ suburb: undefined });
  };

  // const handleAreaChangeField = (selectedZones) => {
  //   setDocumentState((prevState) => ({
  //     ...prevState,
  //     zone_name: selectedZones,
  //     // suburb_id: [],
  //   }));
  // };
  const handleAreaChangeField = (value) => {
    const selectedZone = zones.find((zone) => zone.id === value);
    const zoneName = selectedZone ? selectedZone.zone : "";
    setDocumentState((prevState) => ({
      ...prevState,
      customer_zone: value,
      customer_zone_name: zoneName,
    }));
  };
  const [company, setcompany] = useState();
  const [Tounitofmeasurement, setTounitofmeasurement] = useState([]);
  const handleCompanyChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company: value,
    }));
  };
  const getcompany = async (data) => {
    await getRequest("company/?no_pagination=True", data).then((response) => {
      setcompany(response?.data?.data);
    });
  };
  const getZoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "customer-zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);

    // setZoneList(zoneResponse?.data?.data);
  };

  const handleunitofmeasurementChange = (value) => {
    setStateFilter((prevState) => {
      return {
        ...prevState,
        start_weight_unit_of_measurement: value,
      };
    });
  };
  const handleunitofmeasurementChangeEnd = (value) => {
    setStateFilter((prevState) => {
      return {
        ...prevState,
        end_weight_unit_of_measurement: value,
      };
    });
  };

  const getunitofmeasurement = async (data) => {
    await getRequest("unit-of-measurement/?no_pagination=True", data).then(
      (response) => {
        setunitofmeasurement(response?.data?.data);
      }
    );
  };
  const getunitofmeasurementEnd = async (data) => {
    await getRequest("unit-of-measurement/?no_pagination=True", data).then(
      (response) => {
        setTounitofmeasurement(response?.data?.data);
      }
    );
  };
  const [btnLoadingFile, setBtnLoadingFile] = useState(false);
  const getCompanyList = async (data) => {
    await getRequest("company/?no_pagination=True", data).then((response) => {
      setCompanyList(response?.data?.data);
    });
  };

  const handleApplyFilter = async () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };

  const handleResetFilter = () => {
    setState({
      ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);
    form.setFieldsValue({ search: "" });

    setZones([]);
    // setZones([]);
    formRef.current.setFieldsValue({
      company_name: undefined,
      country: undefined,
      state: undefined,
      customer_zone: undefined,
      start_weight: undefined,
      start_weight_unit_of_measurement: undefined,
      end_weight: undefined,
      end_weight_unit_of_measurement: undefined,
      Price: undefined,
    });
  };
  const handleResetField = () => {
    setDocumentState({
      company: "",
      start_weight: null,
      start_weight_unit_of_measurement: null,
      end_weight: null,
      end_weight_unit_of_measurement: null,
      rate_type: "Variable Rate",
      // currency: "",
      state: null,
      customer_zone: null,
      price: "",
      package_type: null,
    });
    deliveryFormRef.current.setFieldsValue({
      company: null,
      start_weight: null,
      end_weight: null,
      start_weight_unit_of_measurement: null,
      end_weight_unit_of_measurement: null,
      rate_type: "Variable Rate",
      // currency: "",
      state: null,
      customer_zone: null,
      price: "",
      package_type: null,
    });
  };

  const handleRefreshGrid = () => {
    setRefreshGrid((refreshGrid) => !refreshGrid);
  };
  useEffect(() => {
    const getCompanyDocument = async () => {
      setDeliveryRateLoading(true);
      try {
        const apiResponse = await getRequest(
          `delivery-rates/${companyDocumentId}`
        );

        if (apiResponse.data.success) {
          const datas = apiResponse.data.data;

          setDocumentState({
            company: datas.company,
            // currency: datas.currency,
            employee: datas.employee,
            employee_name: datas.employee_name,
            end_weight_unit_of_measurement:
              datas.end_weight_unit_of_measurement,
            id: datas.id,
            rate_type: datas.rate_type,
            start_weight_unit_of_measurement:
              datas.start_weight_unit_of_measurement,
            end_weight: datas.end_weight,
            start_weight: datas.start_weight,
            state: datas.state,
            customer_zone: datas.customer_zone,
            price: datas.price,
            package_type: datas?.package_type,
          });

          deliveryFormRef.current.setFieldsValue({
            company: datas.company,
            // currency: datas.currency,
            employee: datas.employee,
            state: datas.state,
            end_weight: datas.end_weight,
            start_weight: datas.start_weight,
            employee_name: datas.employee_name,
            // end_unit_of_measurement: datas.end_unit_of_measurement,
            id: datas.id,
            rate_type: datas.rate_type,
            // start_unit_of_measurement: datas.start_unit_of_measurement,
            end_weight_unit_of_measurement_name:
              datas.end_weight_unit_of_measurement_name,
            start_weight_unit_of_measurement:
              datas.start_weight_unit_of_measurement,
            end_weight_unit_of_measurement:
              datas.end_weight_unit_of_measurement,
            start_weight_unit_of_measurement_name:
              datas.start_weight_unit_of_measurement_name,
            end_unit_of_measurement: datas.end_weight_unit_of_measurement,
            start_unit_of_measurement: datas.start_weight_unit_of_measurement,
            state: datas.state,
            customer_zone: datas.customer_zone,
            price: datas.price,
            package_type: datas?.package_type,
          });
          setDeliveryRateLoading(false);
        } else {
          ErrorNotificationMsg(t("err_getSubscription"));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        ErrorNotificationMsg(t("err_getSubscription"));
        setDeliveryRateLoading(false);
      } finally {
        setDeliveryRateLoading(false);
      }
    };

    if (companyDocumentId !== null) {
      getCompanyDocument();
    }
  }, [companyDocumentId, t]);

  const colors = ["#737373"];
  const handleDeliveryRateSubmit = async () => {
    const payload = {
      // employee: CompanyId,
      company: documentState.company,
      start_weight_unit_of_measurement:
        documentState.start_weight_unit_of_measurement
          ? documentState.start_weight_unit_of_measurement
          : null,
      start_weight: documentState.start_weight,
      end_weight_unit_of_measurement:
        documentState.end_weight_unit_of_measurement
          ? documentState.end_weight_unit_of_measurement
          : null,
      end_weight: documentState.end_weight,
      rate_type: documentState.rate_type,
      // currency: documentState.currency ? documentState.currency : "AUD",
      price: documentState.price,
      customer_zone: documentState.customer_zone,
      state: documentState.state,
      package_type: documentState.package_type,
      // zone : documentState.
      // company: CompanyId,
      // weight_start: "",
      // start_unit_of_measurement: "",
      // weight_end: "",
      // end_unit_of_measurement: "",
      // rate: "",
      // currency: "",
    };

    try {
      setBtnLoadingFile(true);

      let apiResponse;
      if (companyDocumentId === null) {
        apiResponse = await postRequest("delivery-rates/", payload);
      } else {
        apiResponse = await patchRequest(
          `delivery-rates/${companyDocumentId}/`,
          payload
        );
      }

      if (apiResponse.data.success === true) {
        handleRefreshGrid();

        SuccessNotificationMsg(
          companyDocumentId === null
            ? t("delivery_rate_added_successfully")
            : t("delivery_rate_updated_successfully")
        );
        setCompanyDocumentId(null);
        handleResetField();

        setBtnDisplay("Add");

        setBtnLoadingFile(false);
      }
      // setBtnLoading(false);
    } catch (error) {
      // setBtnLoading(false);
      setBtnLoadingFile(false);
    }
  };
  const handlestartunitofmeasurementChange = (value) => {
    setDocumentState((prevState) => {
      return {
        ...prevState,
        start_weight_unit_of_measurement: value,
      };
    });
  };
  const handleendunitofmeasurementChange = (value) => {
    setDocumentState((prevState) => {
      return {
        ...prevState,
        end_weight_unit_of_measurement: value,
      };
    });
  };
  const handlecompany = (value) => {
    setDocumentState((prevState) => {
      return {
        ...prevState,
        company: value,
      };
    });
  };
  return (
    <>
      <div className="mainwrapper">
        <section className="grid-sec">
          <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
                <h3>Company Delivery Rate</h3>

                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">{t("home")}</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    {t("Company Delivery Rate")}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <Space>
                <div className="searchwrp">
                  <Space direction="vertical">
                    <Form form={form}>
                      <Form.Item name="search" initialValue="">
                        <Search
                          prefix={
                            <img
                              src={SearchIcon}
                              alt="SearchIcon"
                              className="SearchIcon"
                              width={22}
                            />
                          }
                          placeholder={t("pl_search_list")}
                          onChange={searchCallbackDelayed}
                        />
                      </Form.Item>
                    </Form>
                  </Space>
                </div>
                {state?.search ? (
                  // <Tooltip title="Reset search">
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="button"
                    label={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    }
                    onClick={handleResetFilter}
                  />
                ) : (
                  // </Tooltip>
                  ""
                )}
                {/* <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Create New Delivery Rate For Organizing.
                  </span>
                }
              > */}
                {/* {authUserData()?.permission.includes(
                  "settings|add_deliveryrates",
                ) && (
                    <Button
                      className="BlueShadowBtn"
                      type="primary"
                      // onClick={handleAdd}
                      onClick={() => navigate("/deliveryrate/add")}
                      style={{
                        width: 150,
                      }}
                      icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                    >
                      {t("pl_adddeliveryrate")}
                    </Button>
                  )} */}
                {/* </Tooltip> */}
                {/* <Modal
                className="ModelPopupSec"
                title={
                  deliveryratesID ? t("Edit Delivery Rate") : t("Delivery Rate")
                }
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                wrapClassName="modal-wrapper"
                keyboard={false}
              >
                <Deliveryrate
                  zoneList={zoneList}
                  reload={reload}
                  setReload={setReload}
                  handleCancel={handleCancel}
                  deliveryratesID={deliveryratesID}
                  modalKey={modalKey}
                  setStateM={setState}
                />
              </Modal> */}

                <Modal
                  className="ModelPopupSec"
                  title="Upload File"
                  open={isModalOpenBulk}
                  onOk={handleOkBulk}
                  onCancel={handleCancelBulk}
                  closable={false}
                  wrapClassName="modal-wrapper"
                >


                   <BulkRateUploadExcel
                                    setNewRateAdded={setNewRateAdded}
                                    newRateAdded={newRateAdded}
                                    rateId={rateId}
                                    handleCancelBulk={handleCancelBulk}
                                  />
                </Modal>
                
                {authUserData()?.permission.includes(
                  "settings|delete_deliveryrates"
                ) && (
                  <>
                    {selectedRow.length > 0 && (
                      <Popconfirm
                        className="action"
                        title={t("pop_delete")}
                        okText={t("pop_ok")}
                        cancelText={t("pop_cancel")}
                        placement="left"
                        onConfirm={() => handleArchive()}
                      >
                        <ButtonField
                          className="BlueShadowBtn"
                          type="primary"
                          htmlType="button"
                          label={
                            <>
                              <div
                                className="BlueShadowBtn"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <ArchiveButtonicon />
                                <span>{t("pl_archive")}</span>
                              </div>
                            </>
                          }
                        />
                      </Popconfirm>
                    )}
                  </>
                )}

<Tooltip placement="topLeft" title="Excel Upload">
                <ButtonField
                  className="Savegradiantbtncsv"
                  type="primary"
                  htmlType="primary"
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                      }}
                    >
                      <UploadOutlined style={{ fontSize: "16px" }} /> Upload
                      Excel
                    </span>
                  }
                  onClick={showBulkUploadExcel}
                  // disabled={!checked || btnLoading}
                />
                 </Tooltip>
                {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
                <div className="gridiconswrap">
                  <Dropdown
                    overlay={columnMenu}
                    trigger={["click"]}
                    placement="bottomRight"
                    overlayClassName="customdropdwn"
                    visible={dropdownVisible}
                    onVisibleChange={(visible) => setDropdownVisible(visible)}
                  >
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<InsertRowLeftOutlined />}
                      onClick={() => setDropdownVisible(!dropdownVisible)}
                    />
                  </Dropdown>
                </div>
                {/* </Tooltip> */}
              </Space>
            </div>
          </div>

          <div className="Package-body">
            <div className="deliveryfilter">
              <Spin spinning={deliveryRateLoading}>
                <Form
                  onFinish={handleDeliveryRateSubmit}
                  autoComplete="off"
                  ref={deliveryFormRef}
                  layout="vertical"
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <Form.Item
                        name="company"
                        label={t("company")}
                        placeholder={t("pl_select_company")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_select_company")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("pl_select_company")}
                          showArrow
                          showSearch
                          value={deliveryrates?.company}
                          name="company"
                          optionFilterProp="children"
                          onChange={(value) => handlecompany(value)}
                        >
                          {company?.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.company_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <Form.Item
                        name="package_type"
                        label={t("Package Type")}
                        placeholder={t("pl_select_company")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("Select Package Type")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("Select Package Type")}
                          showArrow
                          showSearch
                          value={documentState?.package_type}
                          name="package_type"
                          optionFilterProp="children"
                          onChange={(value) => handlePackageType(value)}
                        >
                          {packageType?.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.package_type}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <Form.Item
                        name="rate_type"
                        label={t("Rate Type")}
                        value={documentState?.rate_type}
                        // initialValue={stateab?.rate || "Flat Rate"}
                        // defaultValue={stateab?.rate || "Flat Rate"}
                      >
                        <Select
                          showArrow
                          placeholder={t("Select Rate Type")}
                          onChange={(value) => handleRateTypeChange(value)}
                          defaultValue={
                            documentState?.rate_type || "Variable Rate"
                          }
                        >
                          <Option key="Flat Rate" value="Flat Rate">
                            Flat Rate
                          </Option>
                          <Option key="Variable Rate" value="Variable Rate">
                            Variable Rate
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <Form.Item
                        name="state"
                        label={t("pl_state")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_select_state")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          name="state"
                          label={t("pl_state")}
                          placeholder={t("pl_select_state")}
                          // value={documentState?.state}
                          // onChange={handleStateSelectChange}
                          onChange={handleStateSelectChangeField}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                        >
                          {statesField.map((state) => (
                            <Option key={state.id} value={state.id}>
                              {state.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <Form.Item
                        name="customer_zone"
                        label={t("pl_area")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("val_select_area")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          name="customer_zone"
                          label={t("pl_area")}
                          placeholder={t("val_area")}
                          onChange={handleAreaChangeField}
                          // value={documentState?.customer_zone}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                        >
                          {zonesField.map((customer_zone) => (
                            <Option
                              key={customer_zone.id}
                              value={customer_zone.id}
                            >
                              {customer_zone.customer_zone}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    {documentState?.rate_type === "Variable Rate" && (
                      <>
                        <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                          <Form.Item
                            name="start_weight"
                            label={t("from_weight")}
                            rules={[
                              {
                                // required: true,
                                pattern: /^[0-9]+(\.[0-9]+)?$/,
                                message: <Trans>{t("val_weight_from")}</Trans>,
                              },
                            ]}
                            initialValue={documentState?.start_weight}
                          >
                            <Input
                              name="start_weight"
                              value={documentState?.start_weight}
                              onChange={handleInputChange}
                              placeholder={t("pl_enter_from_weight")}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                          <Form.Item
                            name={"start_weight_unit_of_measurement"}
                            label={t("label_unit_of_measurement")}
                            // rules={[
                            //   {
                            //     required: false,
                            //     message: <Trans>{t("val_select_UoM")}</Trans>,
                            //   },
                            // ]}
                          >
                            <Select
                              name={"start_weight_unit_of_measurement"}
                              placeholder={t("pl_unit_of_measurement")}
                              showArrow
                              showSearch
                              value={
                                documentState?.start_weight_unit_of_measurement
                              }
                              optionFilterProp="children"
                              onChange={(value) =>
                                handlestartunitofmeasurementChange(value)
                              }
                            >
                              {unitofmeasurement?.map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                          <Form.Item
                            name="end_weight"
                            label={t("to_weight")}
                            // rules={[
                            //   {
                            //     required: false,
                            //     pattern: /^[0-9]+(\.[0-9]+)?$/,
                            //     message: <Trans>{t("val_weight_end")}</Trans>,
                            //   },
                            // ]}
                            initialValue={documentState?.end_weight}
                          >
                            <Input
                              type="text"
                              name="end_weight"
                              value={documentState?.end_weight}
                              onChange={handleInputChange}
                              placeholder={t("pl_enter_weight_end")}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                          <Form.Item
                            name="end_weight_unit_of_measurement"
                            label={t("label_unit_of_measurement")}
                            // rules={[
                            //   {
                            //     required: false,
                            //     message: <Trans>{t("val_select_UoM")}</Trans>,
                            //   },
                            // ]}
                          >
                            <Select
                              name="end_weight_unit_of_measurement"
                              placeholder={t("pl_unit_of_measurement")}
                              showArrow
                              showSearch
                              value={
                                documentState?.end_weight_unit_of_measurement
                              }
                              optionFilterProp="children"
                              onChange={(value) =>
                                handleendunitofmeasurementChange(value)
                              }
                            >
                              {Tounitofmeasurement?.map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </>
                    )}
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <Form.Item
                        name="price"
                        label={t("Price")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("pl_enter_price")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: <Trans>{t("pl_enter_valid_price")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="price"
                          value={documentState?.price}
                          onChange={handleInputChange}
                          placeholder={t("val_enter_price")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        // label={t("Add")}
                        label={t(btnDisplay)}
                        htmlType="Submit"
                        // loading={btnLoading}
                        loading={btnLoadingFile}
                      />
                    </Col>
                  </Row>
                </Form>
              </Spin>
            </div>
            <Collapse
              defaultActiveKey={["1"]}
              style={{ paddingBottom: "16px" }}
            >
              <Panel header="Filters" key="1">
                <div
                  className="deliveryfilter"
                  style={{ paddingTop: "10px", paddingBottom: "0" }}
                >
                  <Form autoComplete="off" ref={formRef} layout="vertical">
                    <Space wrap size={[16, 10]}>
                      {/* <Col >
                        <Form.Item
                          name="country"
                          label={t("pl_country")}
                          placeholder={t("pl_select_country")}
                        >
                          <Select
                            placeholder={t("pl_select_country")}
                            showArrow
                            showSearch
                            value={stateFilter?.country}
                            name="country"
                            optionFilterProp="children"
                            onChange={(value) =>
                              handleCountrySelectChange(value)
                            }
                            style={{ width: "120px" }}
                          >
                            {countryName?.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col> */}

                      <Form.Item name="state" label={t("pl_state")}>
                        <Select
                          name="state"
                          label={t("pl_state")}
                          placeholder={t("pl_select_state")}
                          value={stateFilter.state}
                          onChange={handleStateSelectChange}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                          style={{ width: "140px" }}
                        >
                          {states.map((state) => (
                            <Option key={state.id} value={state.id}>
                              {state.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item name="customer_zone" label={t("pl_area")}>
                        <Select
                          name="customer_zone"
                          label={t("pl_area")}
                          placeholder={t("val_area")}
                          onChange={handleAreaChange}
                          // value={stateFilter.customer_zone}
                          showArrow
                          mode="multiple"
                          showSearch
                          optionFilterProp="children"
                          style={{ width: "100px" }}
                        >
                          {zones?.map((item) => (
                            <Option key={item.id} value={item.customer_zone}>
                              {item.customer_zone}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item name="company_name" label={t("Company")}>
                        <Select
                          name="company"
                          label={t("Company")}
                          placeholder={t("pl_select_company")}
                          onChange={(value) => handleCompanyChange(value)}
                          value={stateFilter?.company}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                          style={{ width: "130px" }}
                        >
                          {companyList?.map((item) => (
                            <Option key={item.id} value={item.company}>
                              {item.company_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        name="start_weight"
                        label={t("from_weight")}
                        initialValue={stateFilter?.start_weight}
                      >
                        <Input
                          type="text"
                          name="start_weight"
                          value={stateFilter?.start_weight}
                          onChange={(value) =>
                            handleChange("start_weight", value)
                          }
                          placeholder={t("from_weight")}
                          style={{ width: "100px" }}
                        />
                      </Form.Item>

                      <Form.Item
                        name="start_weight_unit_of_measurement"
                        label={t("UoM.")}
                        placeholder={t("UoM.")}
                      >
                        <Select
                          placeholder={t("UoM.")}
                          showArrow
                          showSearch
                          value={state?.start_weight_unit_of_measurement}
                          name="start_weight_unit_of_measurement"
                          optionFilterProp="children"
                          onChange={(value) =>
                            handleunitofmeasurementChange(value)
                          }
                          style={{ width: "80px" }}
                        >
                          {unitofmeasurement?.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        name="end_weight"
                        label={t("to_weight")}
                        initialValue={state?.end_weight}
                      >
                        <Input
                          type="text"
                          name="end_weight"
                          value={state?.end_weight}
                          onChange={(value) =>
                            handleChange("end_weight", value)
                          }
                          placeholder={t("to_weight")}
                          style={{ width: "100px" }}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_weight_unit_of_measurement"
                        label={t("UoM.")}
                        placeholder={t("UoM.")}
                      >
                        <Select
                          placeholder={t("label_unit_of_measurement")}
                          showArrow
                          showSearch
                          value={state?.end_weight_unit_of_measurement}
                          name="end_weight_unit_of_measurement"
                          optionFilterProp="children"
                          onChange={(value) =>
                            handleunitofmeasurementChangeEnd(value)
                          }
                          style={{ width: "80px" }}
                        >
                          {unitofmeasurement?.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {/* <Tooltip placement="topLeft" title="Apply Filter"> */}
                      <Button
                        className="BlueShadowBtnRoute"
                        type="primary"
                        htmlType="button"
                        // label="Apply"
                        onClick={handleApplyFilter}
                      >
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                          Filter
                        </span>
                      </Button>
                      {/* </Tooltip> */}
                      {stateFilter?.country ||
                      stateFilter?.state_name ||
                      // stateFilter?.suburb_id.length!==0 ||
                      // stateFilter?.postcode_id.length!==0 ||
                      stateFilter?.customer_zone_name.length !== 0 ||
                      stateFilter?.company ||
                      stateFilter?.start_weight ||
                      stateFilter?.start_weight_unit_of_measurement ||
                      stateFilter?.end_weight ||
                      stateFilter?.end_weight_unit_of_measurement ? (
                        // <Tooltip placement="topLeft" title="Reset Filter">
                        <Button
                          className="BlueShadowBtnRoute"
                          type="primary"
                          htmlType="Reset"
                          // label="Reset"
                          onClick={handleResetFilter}
                        >
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <UndoOutlined
                              style={{ fontSize: "16px", color: "#fff" }}
                            />{" "}
                            Reset
                          </span>
                        </Button>
                      ) : (
                        // </Tooltip>
                        ""
                      )}
                    </Space>
                  </Form>
                </div>
              </Panel>
            </Collapse>
            <div className="tablewrp">
              <Table
                rowSelection={rowSelection}
                rowKey={(record) => record.id}
                columns={columns.filter((col) => !col.hidden)}
                dataSource={deliveryrates}
                scroll={{ x: 800 }}
                loading={loading}
                pagination={{
                  current: state.page,
                  pageSize: state.pagesize,
                  total: totalCount,
                  showSizeChanger: true,
                  showTotal: (totalCount) => `Total ${totalCount} items`,
                  locale: {
                    items_per_page: "Items / Page", // Text for the size changer
                  },
                }}
                onChange={handleTableChange}
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NewDeliveryRateList;
